/**
 * Created by Ning Jiang on 10/19/2018.
 */

import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {ScreenEvent} from "@nolimitcity/slot-game/bin/core/screen/event/ScreenEvent";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {WinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/WinPresentationController";
import {TimelineLite} from "gsap";
import {TombstoneGameMode} from "../../gamemode/TombstoneGameMode";
import {ITombstoneParsedServerData} from "../../server/data/ITombstoneParsedServerData";
import {TombstoneParsedGameData} from "../../server/data/TombstoneParsedGameData";
import {TombstoneParsedInitData} from "../../server/data/TombstoneParsedInitData";
import {WildJailView} from "./WildJailView";

export class WildJailController extends WinPresentationController {

    private _view:WildJailView;
    private _tombstoneData:ITombstoneParsedServerData;
    private _shouldLock:boolean;
    private _shouldUnlock:boolean;
    private _lockSoundPlayed:boolean = false; // Reuse this one for both lock and unlock because they cannot happen at the same time.
    private _timeline:TimelineLite | null;

    constructor(indexes:[number, number]) {
        super(indexes, {name : "WildJail"});

        this._view = new WildJailView();
    }

    protected addFeatureEventHandlers():void {
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.onInitDataParsed(event.params[0]));
        EventHandler.addEventListener(this, ScreenEvent.GAME_RESTORE, (event:GameEvent) => this.onGameRestore());
    }

    private onInitDataParsed(data:TombstoneParsedInitData):void {
        this.parsePrivateData(data);
    }

    protected parseFeatureGameData(data:TombstoneParsedGameData):void {
        this.parsePrivateData(data);
    }

    private parsePrivateData(data:ITombstoneParsedServerData):void {
        this._tombstoneData = data;
        const isRespinFinished:boolean = this._tombstoneData.mode === GameMode.RESPIN && this._tombstoneData.nextMode != GameMode.RESPIN;
        const isSuperFreespinFinished:boolean = this._tombstoneData.mode === TombstoneGameMode.SUPER_FREESPIN && this._tombstoneData.nextMode != TombstoneGameMode.SUPER_FREESPIN;
        this._shouldUnlock = isRespinFinished || isSuperFreespinFinished;
        this._shouldLock = this._tombstoneData.nextMode === GameMode.RESPIN || this._tombstoneData.nextMode === TombstoneGameMode.SUPER_FREESPIN;
    }

    protected resetFeature():void {
        this._shouldLock = false;
        this._shouldUnlock = false;
        this._lockSoundPlayed = false;
    }

    private onGameRestore():void {
        if(this._tombstoneData.nextMode === GameMode.RESPIN || this._tombstoneData.nextMode === TombstoneGameMode.SUPER_FREESPIN) {
            // sticky wilds in respin and super freespin.
            this._tombstoneData.overlayWilds!.forEach((reelOverlay:boolean[], reelId:number) => {
                if(reelOverlay[0]) {
                    this._view.lockReel(reelId, this._tombstoneData.nextMode, false, false);
                }
            });
        }
    }

    protected hasWin():boolean {
        return this._shouldUnlock || this._shouldLock;
    }

    protected startWinPresentation():void {
        if(this._shouldUnlock) {
            const unlockTimeline:TimelineLite = new TimelineLite({paused : true});
            unlockTimeline.add(this._view.unlockAllReels(this._tombstoneData.mode, true, !this._lockSoundPlayed));
            unlockTimeline.add(() => this.finish());
            this._lockSoundPlayed = true;
            this._timeline = unlockTimeline;
            this._timeline.play();
            return;
        }

        if(this._shouldLock) {
            const lockTimeline:TimelineLite = new TimelineLite({paused : true});
            this._tombstoneData.overlayWildsBeforeSpin!.forEach((reelOverlayBeforeSpin:boolean[], reelId:number) => {
                if(reelOverlayBeforeSpin[0]) {
                    return;
                }
                if(this._tombstoneData.overlayWilds![reelId][0]) {
                    lockTimeline.add(this._view.lockReel(reelId, this._tombstoneData.nextMode, true, !this._lockSoundPlayed), 0);
                    this._lockSoundPlayed = true;
                }
            });
            lockTimeline.add(() => this.finish());
            this._timeline = lockTimeline;
            this._timeline.play();
        }
    }

    protected stopWinPresentation(isAborted:boolean):void {
        if(this._timeline != null) {
            if(this._timeline.isActive()) {
                this._timeline.pause();
                this._timeline.kill();
            }
            this._timeline = null;
        }
        if(isAborted) {
            if(this._shouldUnlock) {
                this._view.unlockAllReels(this._tombstoneData.mode, false, !this._lockSoundPlayed);
                this._lockSoundPlayed = true;
                return;
            }

            if(this._shouldLock) {
                this._tombstoneData.overlayWildsBeforeSpin!.forEach((reelOverlayBeforeSpin:boolean[], reelId:number) => {
                    if(reelOverlayBeforeSpin[0]) {
                        return;
                    }
                    if(this._tombstoneData.overlayWilds![reelId][0]) {
                        this._view.lockReel(reelId, this._tombstoneData.nextMode, false, !this._lockSoundPlayed);
                        this._lockSoundPlayed = true;
                    }
                });
            }
        }
    }
}